import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyMobileCTAs from "@/components/StickyMobileCTAs";
import { usePageSeo } from "@/hooks/usePageSeo";

export default function Layout() {
    usePageSeo();

    return (
        <div className="min-h-screen flex flex-col" data-testid="root-layout">
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <StickyMobileCTAs />
        </div>
    );
}
